import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, unref as _unref, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "grid-3 gap-sm" }
const _hoisted_2 = { class: "panel span-2" }
const _hoisted_3 = { value: "" }
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "panel" }

import { onMounted, ref, watch } from 'vue';
import { useGettext } from '@jshmrtn/vue3-gettext';
import { User, UserUpdate, useUser } from '../User';
import { ErrorBag, handleFormError } from '@/core/common';
import { getAllLanguages, Language } from '@/modules/parameters/Language';
import ApiResource from '@/core/http/ApiResource';
import AppFormGroup from '@/core/components/form/AppFormGroup.vue';
import AppButton from '@/core/components/form/AppButton.vue';
import PageLayout from '@/core/components/PageLayout.vue';
import AppInput from '@/core/components/form/AppInput.vue';
import AppSelect from '@/core/components/form/AppSelect.vue';
import UserPermissions from '@/modules/user/components/UserPermissions.vue';

interface UserFormProps {
	resource?: ApiResource<User>;
	pageTitle: string;
	user: User | UserUpdate;
	showCancel: boolean,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'UserForm',
  props: {
    resource: { default: useUser() },
    pageTitle: {},
    user: {},
    showCancel: { type: Boolean, default: true }
  },
  emits: [
	'cancel',
	'saved',
],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const { $gettext } = useGettext();
const languages = ref<Language[]>([]);
const errors = ref<ErrorBag>({});
const data = ref<Partial<User | UserUpdate>>({});

// Set data to form on mount and when the prop value changes.
const setData = async () => {
	data.value = Object.assign({}, props.user);
	languages.value = await getAllLanguages();
};
onMounted(setData);
watch(() => props.user, setData);

const save = async () => {
	errors.value = {};

	const postBody: UserUpdate = Object.assign({}, data.value) as UserUpdate;
	delete postBody.permissions;

	if (typeof postBody.password !== 'undefined' && postBody.password === '') {
		delete postBody.password;
	}

	let promise: Promise<User>;
	if (props.user?.id) {
		promise = props.resource.put(props.user.id, postBody);
	} else {
		promise = props.resource.post(postBody);
	}

	try {
		let response = await promise;

		if (typeof data.value.permissions !== 'undefined') {
			response = await props.resource.putPermissions(response.id, data.value.permissions);
		}

		emit('saved', response);

	} catch (e) {
		return handleFormError(e as Error, errors);
	}
};

return (_ctx: any,_cache: any) => {
  const _component_translate = _resolveComponent("translate")!
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createBlock(PageLayout, {
    "page-title": _ctx.pageTitle,
    "base-tag": "form",
    onSubmit: _withModifiers(save, ["prevent"])
  }, _createSlots({
    "header-actions": _withCtx(() => [
      (_ctx.showCancel)
        ? (_openBlock(), _createBlock(AppButton, {
            key: 0,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('cancel')))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_translate, null, {
                default: _withCtx(() => [
                  _createTextVNode("Avbryt")
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(AppButton, { type: "submit" }, {
        default: _withCtx(() => [
          _createVNode(_component_translate, null, {
            default: _withCtx(() => [
              _createTextVNode("Spara")
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 2
  }, [
    (_ctx.user !== null)
      ? {
          name: "content",
          fn: _withCtx(() => [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _withDirectives((_openBlock(), _createElementBlock("h2", null, [
                    _createTextVNode("Användarinformation")
                  ])), [
                    [_directive_translate]
                  ]),
                  _createVNode(AppFormGroup, {
                    id: "user_name",
                    errors: errors.value.name,
                    label: _unref($gettext)('Namn')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(AppInput, {
                        id: "user_name",
                        modelValue: data.value.name,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((data.value.name) = $event)),
                        required: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["errors", "label"]),
                  _createVNode(AppFormGroup, {
                    id: "user_email",
                    errors: errors.value.email,
                    label: _unref($gettext)('E-post')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(AppInput, {
                        type: "email",
                        id: "user_email",
                        modelValue: data.value.email,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((data.value.email) = $event)),
                        required: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["errors", "label"]),
                  _createVNode(AppFormGroup, {
                    id: "user_password",
                    errors: errors.value.password,
                    label: _unref($gettext)('Lösenord')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(AppInput, {
                        type: "password",
                        id: "user_password",
                        modelValue: data.value.password,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((data.value.password) = $event)),
                        placeholder: "********",
                        required: !data.value.id
                      }, null, 8, ["modelValue", "required"])
                    ]),
                    _: 1
                  }, 8, ["errors", "label"]),
                  _createVNode(AppFormGroup, {
                    id: "user_language",
                    errors: errors.value.language,
                    label: _unref($gettext)('Språk')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(AppSelect, {
                        id: "user_language",
                        modelValue: data.value.language,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((data.value.language) = $event)),
                        required: ""
                      }, {
                        default: _withCtx(() => [
                          _withDirectives((_openBlock(), _createElementBlock("option", _hoisted_3, [
                            _createTextVNode("(Välj)")
                          ])), [
                            [_directive_translate]
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(languages.value, (language) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: language.id,
                              value: language.id
                            }, _toDisplayString(language.name), 9, _hoisted_4))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["errors", "label"])
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _withDirectives((_openBlock(), _createElementBlock("h2", null, [
                    _createTextVNode("Behörigheter")
                  ])), [
                    [_directive_translate]
                  ]),
                  (data.value.type)
                    ? (_openBlock(), _createBlock(UserPermissions, {
                        key: 0,
                        "model-value": data.value.permissions,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((data.value.permissions) = $event)),
                        "user-type": data.value.type
                      }, null, 8, ["model-value", "user-type"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["page-title", "onSubmit"]))
}
}

})